import { ServicesComponent } from './sop/services/services.component';
import { AssignedServiceComponent } from './sop/assigned-service/assigned-service.component';
import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { EpesComponent } from './sop/epes/epes.component';
import { ProjectsComponent } from './sop/projects/projects.component';
import { AssociationComponent } from './sop/association/association.component';
import { AuthGuard } from './auth/auth.guard';
import { MeetingFormComponent } from './form/meeting-form/meeting-form.component';
import { EpeComponent } from './sop/epe/epe.component';
import { ProjectComponent } from './sop/project/project.component';
import { SurveysComponent } from './sop/surveys/surveys.component';
import { SurveyDashboardComponent } from "./survey-dashboard/survey-dashboard.component";
import { StatisticsComponent } from './sop/statistics/statistics.component';
import {DeepDiveComponent} from "./sop/deep-dive/deep-dive.component";
import {AssignedDeepDiveComponent} from "./sop/assigned-deep-dive/assigned-deep-dive.component";
import {CwaComponent} from "./sop/cwa/cwa.component";
import {AssignedCwaComponent} from "./sop/assigned-cwa/assigned-cwa.component";

const routes: Routes =[

{
    path: '',
    component: AdminLayoutComponent,
},
{ 
    path: 'project/:id',
    component: ProjectComponent,
    canActivate: [AuthGuard]
},
{ 
    path: 'epe/:id',
    component: EpeComponent,
    canActivate: [AuthGuard]
},
{ 
    path: 'epes',
    component: EpesComponent,
    canActivate: [AuthGuard]
},
{ 
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [AuthGuard]
},
{ 
    path: 'associations',
    component: AssociationComponent,
    canActivate: [AuthGuard]
},
{ 
    path: 'assigned-services',
    component: AssignedServiceComponent,
    canActivate: [AuthGuard]
},
{ 
  path: 'services-status',
  component: ServicesComponent,
  canActivate: [AuthGuard]
},
{ 
  path: 'surveys-status',
  component: SurveysComponent,
  canActivate: [AuthGuard]
},
{ 
  path: 'statistics',
  component: StatisticsComponent,
  canActivate: [AuthGuard]
},
{
  path: 'deep-dive',
  component: DeepDiveComponent,
  canActivate: [AuthGuard]
},
{
    path: 'assigned-deep-dive',
    component: AssignedDeepDiveComponent,
    canActivate: [AuthGuard]
},
{
  path: 'cwa',
  component: CwaComponent,
  canActivate: [AuthGuard]
},
{
    path: 'assigned-cwa',
    component: AssignedCwaComponent,
    canActivate: [AuthGuard]
},
{
    path: 'form',
    component: MeetingFormComponent,
    children: [{
      path: '',
      loadChildren:
        () => import('./form/meeting-form/meeting-form.module')
        .then(m => m.MeetingFormModule),
      outlet: 'meeting-form'
    }]
},
{
    path: 'survey-dashboard',
    component: SurveyDashboardComponent,
},
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {useHash: true})
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
